const DETECTORS = [
    {
        match: /^\/analysis\/(.+)$/,
        build: (m, location) => {
            const raw = decodeURIComponent(m[1]);
            return {
                type: 'insight',
                uri: raw,
                label: raw,
                link: location.pathname + (location.search || ''),
            };
        },
    },
    {
        match: /^\/insights\/(.+)$/,
        build: (m, location) => {
            const raw = decodeURIComponent(m[1]);
            return {
                type: 'insight',
                uri: raw,
                label: raw,
                link: location.pathname + (location.search || ''),
            };
        },
    },
];

export function registerContextDetector(detector) {
    if (!detector?.match || typeof detector?.build !== 'function') return;
    DETECTORS.push(detector);
}

export function detectContext(location) {
    if (!location?.pathname) return null;
    for (const d of DETECTORS) {
        const m = location.pathname.match(d.match);
        if (m) {
            try {
                return d.build(m, location);
            } catch {
                return null;
            }
        }
    }
    return null;
}
